import { useState } from 'react';
import { Link } from 'react-router-dom';
import { hotTopics } from '@/mocks/articles';

export default function HotTopicsSection() {
  const [hoveredId, setHoveredId] = useState<number | null>(null);

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="mb-10 md:mb-14">
          <h2 className="text-3xl md:text-5xl lg:text-6xl font-heading font-black text-foreground-900 leading-tight">
            热门话题
          </h2>
          <p className="text-sm md:text-base text-foreground-500 mt-3 md:mt-4 font-label">
            全网最火爆的吃瓜话题，实时追踪最新动态
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
          {hotTopics.map((topic) => (
            <Link
              key={topic.id}
              to={`/category/${topic.category}`}
              className="group relative overflow-hidden rounded-xl md:rounded-2xl cursor-pointer"
              style={{ aspectRatio: '3/4' }}
              onMouseEnter={() => setHoveredId(topic.id)}
              onMouseLeave={() => setHoveredId(null)}
            >
              <img
                src={topic.image}
                alt={topic.title}
                title={topic.title}
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent"></div>

              <div className="absolute top-4 left-4">
                <span className={`inline-block px-3 py-1 text-xs font-label font-semibold text-background-50 ${topic.tagColor} rounded-full`}>
                  {topic.tag}
                </span>
              </div>

              <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                <h3 className="text-xl md:text-2xl font-heading font-bold text-background-50 mb-2">
                  {topic.title}
                </h3>
                <p className="text-sm text-background-50/80 font-label mb-3">
                  {topic.subtitle}
                </p>
                <p
                  className={`text-xs text-background-50/60 font-label leading-relaxed transition-all duration-500 overflow-hidden ${
                    hoveredId === topic.id ? 'max-h-20 opacity-100' : 'max-h-0 opacity-0'
                  }`}
                >
                  {topic.description}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}